'use client';
import { CashOutSportList } from '@nf/types/site';
import { createContext, useContext, useState, useMemo, useEffect } from 'react';

interface BetslipContextProps {
	acceptBetterOdds: boolean;
	oddsType: number;
	cashOutSportList: CashOutSportList;
	defaultStakeId: string;
	quickBetStake: number;
	quickStake: string;
	balance: string;
	currencyName: string;
	currencySymbol: string;
	enableRewardSystem: boolean;
	inpbetStake: string;
	isIndependentMode: boolean;
};

interface BetslipProviderProps extends BetslipContextProps {
	children: React.ReactNode;
}

const BetslipContext = createContext<BetslipContextProps>({} as BetslipContextProps);

export const BetslipContextProvider = ({ children, ...props }: BetslipProviderProps) => {

	const [acceptBetterOdds, setAcceptBetterOdds] = useState(props.acceptBetterOdds);
	const [oddsType, setOddsType] = useState(props.oddsType);
	const [cashOutSportList, setCashOutSportList] = useState(props.cashOutSportList);
	const [defaultStakeId, setDefaultStakeId] = useState(props.defaultStakeId);
	const [quickBetStake, setQuickBetStake] = useState(props.quickBetStake);
	const [quickStake, setQuickStake] = useState(props.quickStake);
	const [balance, setBalance] = useState(props.balance);
	const [currencyName, setCurrencyName] = useState(props.currencyName);
	const [currencySymbol, setCurrencySymbol] = useState(props.currencySymbol);
	const [enableRewardSystem, setEnableRewardSystem] = useState(props.enableRewardSystem);
	const [inpbetStake, setInpbetStake] = useState(props.inpbetStake);
	const [isIndependentMode, setIsIndependentMode] = useState(props.isIndependentMode)

	useEffect(() => {
		setAcceptBetterOdds(props.acceptBetterOdds);
		setOddsType(props.oddsType);
		setCashOutSportList(props.cashOutSportList);
		setDefaultStakeId(props.defaultStakeId);
		setQuickBetStake(props.quickBetStake);
		setQuickStake(props.quickStake);
		setBalance(props.balance);
		setCurrencyName(props.currencyName);
		setCurrencySymbol(props.currencySymbol);
		setEnableRewardSystem(props.enableRewardSystem);
		setInpbetStake(props.inpbetStake);
		setIsIndependentMode(props.isIndependentMode);
	}, [props])

	const value = useMemo(() => (
		{
			acceptBetterOdds,
			oddsType,
			cashOutSportList,
			defaultStakeId,
			quickBetStake,
			quickStake,
			balance,
			currencyName,
			currencySymbol,
			enableRewardSystem,
			inpbetStake,
			isIndependentMode
		}
	), [
		acceptBetterOdds,
		oddsType,
		cashOutSportList,
		defaultStakeId,
		quickBetStake,
		quickStake,
		balance,
		currencyName,
		currencySymbol,
		enableRewardSystem,
		inpbetStake,
		isIndependentMode
	]);

	return (
		<BetslipContext.Provider value={value}>
			{children}
		</BetslipContext.Provider>
	);
}

export const useBetslipContext = () => useContext(BetslipContext);





